<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    <span class="treeTitleNum1" style="margin-left: 0" v-if="node.label.split('###')[3]=='X'">{{node.label.split('###')[0]}}</span>
                    <span v-else>{{node.label.split('###')[0]}}</span>
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 304px)">
            <div class="searchBox" v-if="list_model ==1">
                <div class="searchGroup">
                    <label>灌浆类型：</label>
                    <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>孔号：</label>
                    <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>孔数据：</label>
                    <el-select v-model="search_Obj.report_count_type" placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option label="全部" value="9"></el-option>
                        <el-option label="三种报告都有" value="1"></el-option>
                        <el-option label="只有监测报告" value="2"></el-option>
                        <el-option label="只有抽检报告" value="3"></el-option>
                    </el-select>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card class="box-card">
                <div class="mainBody">
                    <div class="dataBox" v-if="list_model ==1">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                            <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="hole_code" label="孔号" sortable="custom" width="120"></el-table-column>
                            <el-table-column prop="hole_order" label="孔序" sortable="custom" width="120"></el-table-column>
                            <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="order_index" label="顺序" sortable="custom" width="100"></el-table-column>
                            <el-table-column label="操作" width="240" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox" v-if="list_model ==1">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                    <div class="titleBoxwhr" v-if="list_model ==2">
                        <h3>
                            孔号：{{work_hole.hole_code}}
                        </h3>
                        <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                    </div>
                    <div class="dataBox" v-if="list_model ==2">
                        <el-table :data="tableData1" v-loading="loading" border stripe>
                            <el-table-column prop="hole_code" label="孔号" width="220"></el-table-column>
                            <el-table-column prop="segment_no" label="段号" width="120"></el-table-column>
                            <el-table-column prop="report_count" label="报告数量" width="120"></el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button  size="mini" plain type="primary" @click="infoAll(scope.row)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <Info
                        :report_type="report_type"
                        :hole_id="hole_id"
                        :segment_no="segment_no"
                        title="查看作业报告"
                        :isshow="infoshow"
                        @on-close="closeInfoDialog">
                    </Info>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { mergeListForContrast } from '@/api/workreport'
import Info from "./info"

export default {
    name: 'reportContrastCheckHole',
    mixins: [listutil],
    components: {Info, Btns, LabBtns},
    data() {
        return {
            m_name: '灌浆数据对比',
            menu_id: 7400,
            list_url: "/api/admin/workhole/list",
            search_Obj: {
                f_hole_code: '',
                f_hole_type: 2,
                report_count_type: '9',
                report_type: 1
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            list_model: 1,
            report_type: 1,
            hole_id: 0,
            segment_no: '',
            tableData1: [],
            work_hole: {},
            
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(112).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            this.list_model = 2
            mergeListForContrast(row.id, this.report_type, this.search_Obj.report_count_type).then(res=>{
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.work_hole = res.data.work_hole
                }
            })
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
        },
        infoAll(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        
    }
};
</script>
